<template>
  <main>
    <div class="container">
      <section class="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-5 col-md-6 d-flex flex-column align-items-center justify-content-center">

              <div class="d-flex justify-content-center py-4">
                <router-link to="/" class="logo d-flex align-items-center w-auto">
                  <img src="assets/img/logo.png" alt="">
                  <span class="d-none d-lg-block">FinPlan</span>
                </router-link>
              </div>

              <div class="card mb-3">

                <div class="card-body" v-if="validToken">

                  <div class="pt-4 pb-2">
                    <h5 class="card-title text-center pb-0 fs-4">Восстановление пароля</h5>
                    <p class="text-center small">Введите новый пароль</p>
                  </div>

                  <form @submit.prevent="onSubmit" v-if="!sent" class="row g-3">

                    <div class="row mb-3">
                      <label for="newPassword" class="col-md-4 col-lg-3 col-form-label">Пароль</label>
                      <div class="col-md-8 col-lg-9">
                        <input v-model="password" name="password" type="password" class="form-control" id="newPassword">
                      </div>
                    </div>

                    <div class="row mb-3">
                      <label for="renewPassword" class="col-md-4 col-lg-3 col-form-label">Повторите пароль</label>
                      <div class="col-md-8 col-lg-9">
                        <input v-model="passwordRepeat" name="passwordRepeat" type="password" class="form-control" id="renewPassword">
                      </div>
                    </div>

                    <div v-if="error" class="invalid-feedback" style="display: block" v-html="error"></div>

                    <div class="col-12 d-flex justify-content-center">
                      <button class="btn btn-primary" :disabled="loading" type="submit">
                        <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                        Подтвердить
                      </button>
                    </div>
                  </form>
                  <div v-if="sent" class="col-12">
                    <p class="small mb-0 text-success">
                      Пароль изменен. Теперь вы можете <router-link to="/auth">войти</router-link>.
                    </p>
                  </div>
                </div>

                <div class="card-body" v-else>
                  <div class="row g-3 mt-3">
                    <p class="small mb-3">
                      Неверная ссылка восстановления пароля. <router-link to="/auth">Назад</router-link>.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </section>

    </div>
  </main>
</template>

<script setup>
import {onMounted, ref} from "vue";
import { usePersonal } from '@/features/personal/composables/usePersonal';
const {
  validResetToken,
  resetPassword,
} = usePersonal();

const props = defineProps({
  token: {
    type: String,
    required: true,
  },
});

const validToken = ref(true);
const password = ref('');
const passwordRepeat = ref('');
const error = ref('');
const loading = ref(false);
const sent = ref(false);

onMounted(async () => {
  validToken.value = await validResetToken(props.token);
});

const onSubmit = async () => {
  if (password.value !== passwordRepeat.value) {
    error.value = "Пароли не совпадают";
    return;
  }
  loading.value = true;
  await resetPassword(props.token, password.value)
  .then(() => {
    sent.value = true;
  })
  .catch((e) => {
    error.value = "Не удалось изменить пароль";
  })
  .finally(() => {
    loading.value = false;
  })
}
</script>
